export default __webpack_public_path__ + "graphics/spinner.0fd69107.svg";